/* Card swatch vs hover photo (client round 6, 3.4; P3/P4 review).

   Be-Yours' <color-swatch> swaps only the FIRST card image on mouseenter. The
   hover photo added in round 6 is the second image, so after touching a
   swatch it either still showed the old colour or matched the new first image
   and did nothing. Once a swatch is touched, the card is marked and CSS turns
   its hover swap off; the swatch is the colour preview from then on.
   Delegated from the document, so cards rendered later (filters, pagination,
   recommendations) are covered with no re-binding. */
(function () {
  'use strict';
  function mark(ev) {
    var sw = ev.target.closest && ev.target.closest('color-swatch');
    if (!sw) return;
    var card = sw.closest('.card-wrapper');
    if (card) card.classList.add('hm-swatched');
  }
  document.addEventListener('mouseover', mark, { passive: true });
  document.addEventListener('focusin', mark);
  document.addEventListener('click', mark, true);
})();
